import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
// import Home from "../views/indexhome.vue";
import Home from "../views/brandnew/index.vue";
Vue.use(VueRouter);

var routes = [{
        path: "/",
        name: "Home",
        component: Home,

    },
    {
        path: "/payGateWay",
        name: "payGateWay",
        component: () =>
            import ("../views/brandnew/payGateWay.vue")

    },
    // {
    //     path: "/login",
    //     name: "Login",
    //     component: () =>
    //         import ("../views/login.vue")
    //
    // },
    {
        path: "/about",
        name: "About",
        component: () =>
            import ("../views/About.vue")
    },
    {
        path: "/ranking",
        name: "ranking",
        component: () =>
            import ("../views/ranking.vue")
    },
    {
        path: "/Institutional",
        name: "Institutional",
        component: () =>
            import ("../views/Institutional.vue")
    },
    {
        path: "/project",
        name: "project",
        component: () =>
            // import( "../views/project.vue")
            import ("../views/innovateproject.vue")

    },
    {
        path: "/notice",
        name: "notice",
        component: () =>
            import ("../views/notice.vue")
    },
    {
        path: "/newscenter",
        name: "newscenter",
        component: () =>
            import ("../views/brandnew/newscenter.vue")
    },
    {
        path: "/newscenterdetail",
        name: "newscenterdetail",
        component: () =>
            import ("../views/brandnew/newscenterdetail.vue")
    },
    {
        path: "/noticeDetails",
        name: "noticeDetails",
        component: () =>
            // import( "../views/noticeDetails.vue")
            import ("../views/brandnew/noticeDetails.vue")
    },
    {
        path: "/informatedisclosure",
        name: "informatedisclosure",
        component: () =>
            import ("../views/informatedisclosure.vue")
    },
    {
        path: "/informatedisclosuredetail",
        name: "informatedisclosuredetail",
        component: () =>
            // import( "../views/informatedisclosuredetail.vue")
            import ("../views/brandnew/informatedisclosuredetail.vue")
    },
    {
        path: "/policiesregulations",
        name: "policiesregulations",
        component: () =>
            import ("../views/policiesregulations.vue")
    },
    {
        path: "/policiesregulationsdetail",
        name: "policiesregulationsdetail",
        component: () =>
            // import( "../views/policiesregulationsdetail.vue")
            import ("../views/brandnew/policiesregulationsdetail.vue")
    },
    {
        path: "/benefitactivities",
        name: "benefitactivities",
        component: () =>
            import ("../views/benefitactivities.vue")
    },
    {
        path: "/benefitactivitiesdetail",
        name: "benefitactivitiesdetail",
        component: () =>
            // import( "../views/benefitactivitiesdetail.vue")
            import ("../views/brandnew/publicbenactdetail.vue")
    },

    {
        path: "/projectDetails",
        name: "projectDetails",
        component: () =>
            // import( "../views/projectDetails.vue")
            import ("../views/brandnew/projectDetails.vue")
    },
    {
        path: "/choice",
        name: "choice",
        component: () =>
            import ("../views/choice.vue")
    },
    {
        path: "/payment",
        name: "payment",
        component: () =>
            // import( "../views/payment.vue")
            import ("../views/brandnew/pubpayment.vue")
    },
    {
        path: "/paymentSuccess",
        name: "paymentSuccess",
        component: () =>
            // import( "../views/payment.vue")
            import ("../views/brandnew/paymentSuccess.vue")
    },

    //新增页面部分--------------------------
    {
        path: "/publicbenact",
        name: "publicbenact",
        component: () =>
            import ("../views/brandnew/publicbenact.vue")
    },
    {
        path: "/publicwelpro",
        name: "publicwelpro",
        component: () =>
            import ("../views/brandnew/publicwelpro.vue")
    },
    {
        path: "/lovelist",
        name: "lovelist",
        component: () =>
            import ("../views/brandnew/lovelist.vue")
    },
    {
        path: "/lovelist_box",
        name: "lovelist_box",
        component: () =>
            import ("../views/brandnew/lovelist_box.vue")
    },
    {
        path: "/lovelist_detail",
        name: "lovelist_detail",
        component: () =>
            import ("../views/brandnew/lovelist_detail.vue")
    },
    {
        path: "/informdisclosure",
        name: "informdisclosure",
        component: () =>
            import ("../views/brandnew/informdisclosure.vue")
    },
    {
        path: "/publicannounce",
        name: "publicannounce",
        component: () =>
            import ("../views/brandnew/publicannounce.vue")
    },
    {
        path: "/aboutus",
        name: "aboutus",
        component: () =>
            import ("../views/brandnew/aboutus.vue")
    },
    {
        path: "/policiesandregulations",
        name: "policiesandregulations",
        component: () =>
            import ("../views/brandnew/policiesandregulations.vue")
    },
    {
        path: "/applyforhelp",
        name: "applyforhelp",
        component: () =>
            import ("../views/brandnew/applyforhelp.vue")
    },



];
var router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
